export enum CommentsError {
	COMMENT_ERROR = 'There was an error loading Comments. Please try again.',
	UPDATE_ERROR = 'Error update Status',
	
}